


































import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class WarningIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#FFBE40' }) readonly fill?: string;
}
